import {Model} from '@/models/Model'
import {DataPromotionsArray, Promotion} from '@/models/Promotion'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const CampaignConst = Object.freeze({
  TYPE_TEST: 20,

  map(status: number): string {
    switch (status) {
      case CampaignConst.TYPE_TEST:
        return 'Test'
    }
    return ''
  },
})


export class Campaign extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  datetime_start: Date | string | null
  datetime_end: Date | string | null
  enabled: boolean | null
  price_group: number | null

  promotions: Promotion[]

  getResourceURL(): string {
    return Helper.setting.campaign.getResourceAPI
  }


  public async loadPromotions(): Promise<DataPromotionsArray> {
    return await new Promise<DataPromotionsArray>((resolve, reject) => {
      Helper.get(Helper.setting.campaign.getPromotionAPI.replace('{id}', this.id))
        .then<{ data: DataPromotionsArray }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }

}

export class DataCampaignsArray extends DataArray {

  declare data: Campaign[]
  filter: FilterCampaign = new FilterCampaign()
}


export class FilterCampaign {
  price_group: FilterSet = new FilterSet()
}


export class DataCampaign extends DataResource {

  declare data: Campaign

}
